import { ClearAll, FiltersSelected, Sensors, SortBy, Stats } from "@usereactify/search";
import React, { useState } from "react";
import { Filters } from "../Filters/filters";
import { FacetsSelected } from "./facets-selected";
import { Sort } from "../Sort/sort";

export const MobileFilterBar = () => {
  const [isPanelActive, setPanelActive] = useState(false);

  return (
    <div className="facets-mobile-container facets">
      <div className="facets__wrapper mobile" onClick={() => setPanelActive(!isPanelActive)}>
        <label className="fw-bold mobile-facets__label">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line
              x1="2.9375"
              y1="9.03284"
              x2="22.0643"
              y2="9.03284"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
            />
            <line
              x1="2.9375"
              y1="18.2332"
              x2="22.0643"
              y2="18.2332"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
            />
            <circle cx="8.53131" cy="8.82965" r="3.00397" fill="white" stroke="black" stroke-width="2" />
            <circle cx="16.504" cy="18.3708" r="3.00397" fill="white" stroke="black" stroke-width="2" />
          </svg>
          Filter and sort
        </label>
        <div className="thb-filter-count top-bar">
          <span className="facets__label">
            <Stats
              render={(renderProps) => {
                const results = renderProps?.resultStats?.numberOfResults;
                if (!results) return null
                return (
                  <div className="facets__selected">
                    {results && results <= 1 ? `${results} Product` : `${results} Products`}
                  </div>
                );
              }}
            />
          </span>
        </div>
      </div>
      <div className={`bg-panel ${isPanelActive ? "active" : "no-js-hidden"}`}>
        <div className={`side-panel facet-drawer ${isPanelActive ? "active" : "no-js-hidden"}`}>
          <div className="side-panel-inner">
            <div className="side-panel-header">
              <h3>Filter and sort</h3>
              <div className="side-panel-sub-header">
                <span className="thb-filter-count mobile-filter-count body-font loading">
                  <Stats
                    render={(renderProps) => {
                      const results = renderProps?.resultStats?.numberOfResults;
                      if (!results) return null
                      return (
                        <span className="facets__selected">
                          {results && results <= 1 ? `${results} Product` : `${results} Products`}
                        </span>
                      );
                    }}
                  />
                </span>
                <span onClick={() => setPanelActive(false)}>Close</span>
              </div>
            </div>
            <div className="thb-filter-sort">
              <Filters isSidePanel={true} />
              <div className="sort-by-wrapper side-panel-content">
                <label className="fw-bold thb-filter-title">{`Sort by`}</label>
                <SortBy render={(props) => <Sort sortListProps={props as any} />} />
              </div>
            </div>
          </div>
          <div className="button-section">
            <div className="button secondary accent2" onClick={() => setPanelActive(!isPanelActive)}>
              {`Apply`}
            </div>
            <div className="button outline secondary">
              {`Clear`}
              <ClearAll />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DesktopFilterBar: React.FC = () => {
  return (
    <>
      <div className="facets-desktop-container facets">
        <div className="facets__wrapper">
          <label className="fw-bold facets__label">{`Filter`}</label>
          <Filters />
        </div>
        <div className="thb-filter-sort-count">
          <label className="fw-bold facets__label">{`Sort by`}</label>
          <div className="thb-filter-sort">
            <SortBy render={(props) => <Sort sortListProps={props as any} />} />
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 8L12 16L4 8"
                stroke="#2B2B2B"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="thb-filter-count">
            <span className="facets__label">
              <Stats
                render={(renderProps) => {
                  const results = renderProps?.resultStats?.numberOfResults;
                  if (!results) return null
                  return (
                    <div className="facets__selected">
                      {results && results <= 1 ? `${results} Product` : `${results} Products`}
                    </div>
                  );
                }}
              />
            </span>
          </div>
        </div>
      </div>
      <div className="selected-filters-container">
        <FiltersSelected render={(props) => <FacetsSelected {...props} />} />
        <ClearAll />
      </div>
    </>
  );
};
